
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.922 0h17.847C24.996 0 26 1.035 26 2.3V23l-2.23-1.99-2.576-2.61H5.921c-1.227 0-2.23-1.035-2.23-2.3v-.94h2.443v1.333H21.75l2.231 2.356V2.356H6.135v.78H3.691V2.3c0-1.265 1.004-2.3 2.231-2.3zM7.1 4.202H2.94L0 7.116v4.124l2.94 2.914H7.1l2.939-2.914V7.116l-2.94-2.914zm1.824 6.58l-2.287 2.266H3.402l-2.287-2.267V7.575l2.287-2.267h3.235l2.287 2.267v3.206zm-4.406 1.16v-.921h.93v.921h-.93zm1.394-3.686a.928.928 0 00-.93-.921.928.928 0 00-.93.921h-.929a1.85 1.85 0 011.86-1.843A1.85 1.85 0 016.84 8.256c0 .591-.367.91-.724 1.22-.34.293-.67.58-.67 1.084h-.93c0-.84.438-1.172.823-1.464.302-.23.572-.435.572-.84z","fill":"#fff"}})])
          )
        }
      }
    